module.exports = __webpack_public_path__ + "static/media/codeparallaxis.787e66ee.png";